import './Pagination.scss';

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getLister } from '../../actions/lister-actions';

import PaginationButton from './PaginationButton';
import PaginationCurrent from './PaginationCurrent';
import PaginationMoreButton from './PaginationMoreButton';
import PaginationPrevButton from './PaginationPrevButton';

export const Pagination = () => {
	const dispatch = useDispatch();
	const { pages, currentPageNumber } = useSelector((state) => state);

	const handlePagination = (url) => {
		dispatch(
			getLister(url, {
				type: '',
				trackHistory: true,
			})
		);

		window.scrollTo({
			top: 0,
			left: 0,
			behavior: 'auto',
		});
	};

	if (pages) {
		return (
			<ul
				className="hidden md:flex justify-center items-center"
				data-testid="desktopViewPagination">
				{pages.PreviousPageUrl && (
					<PaginationPrevButton
						handlePagination={handlePagination}
						url={pages.PreviousPageUrl}
					/>
				)}

				{Array.isArray(pages.Pages) &&
					pages.Pages.map((page) => {
						if (currentPageNumber !== page.Index) {
							return (
								<PaginationButton
									handlePagination={handlePagination}
									url={page.Url}
									index={page.Index}
									key={page.Url}
								/>
							);
						}

						return <PaginationCurrent index={page.Index} key={page.Url} />;
					})}

				{pages.NextPageUrl && (
					<PaginationMoreButton
						handlePagination={handlePagination}
						url={pages.NextPageUrl}
					/>
				)}
			</ul>
		);
	}

	return null;
};

export default Pagination;
